/**
 * @generated SignedSource<<18ebe3dd7e098a3bf9cb66c9e53fdb0a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateUserRelationshipTypesInput = {
  clientMutationId?: string | null | undefined;
  relationshipTypeIds?: ReadonlyArray<any | null | undefined> | null | undefined;
};
export type useUserRelationshipTypesMutation$variables = {
  input: UpdateUserRelationshipTypesInput;
};
export type useUserRelationshipTypesMutation$data = {
  readonly updateUserRelationshipTypes: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useUserRelationshipTypes_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useUserRelationshipTypesMutation = {
  response: useUserRelationshipTypesMutation$data;
  variables: useUserRelationshipTypesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserRelationshipTypesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserRelationshipTypesPayload",
        "kind": "LinkedField",
        "name": "updateUserRelationshipTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useUserRelationshipTypes_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUserRelationshipTypesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserRelationshipTypesPayload",
        "kind": "LinkedField",
        "name": "updateUserRelationshipTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "UserRelationshipTypeConnection",
                    "kind": "LinkedField",
                    "name": "userRelationshipTypes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserRelationshipType",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "relationshipTypeId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "userRelationshipTypes(orderBy:[\"RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "af362cd9156e47e26b8d3c9853df05a7",
    "id": null,
    "metadata": {},
    "name": "useUserRelationshipTypesMutation",
    "operationKind": "mutation",
    "text": "mutation useUserRelationshipTypesMutation(\n  $input: UpdateUserRelationshipTypesInput!\n) {\n  updateUserRelationshipTypes(input: $input) {\n    query {\n      ...useUserRelationshipTypes_query\n      id\n    }\n  }\n}\n\nfragment useUserRelationshipTypes_query on Query {\n  currentUser {\n    userRelationshipTypes(orderBy: [RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC]) {\n      nodes {\n        relationshipTypeId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1d1542b627aa527b57f1321a56ae714e";

export default node;
